import { render, staticRenderFns } from "./LeavePermission.vue?vue&type=template&id=8c03e256&scoped=true"
import script from "./LeavePermission.vue?vue&type=script&lang=js"
export * from "./LeavePermission.vue?vue&type=script&lang=js"
import style0 from "./LeavePermission.vue?vue&type=style&index=0&id=8c03e256&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c03e256",
  null
  
)

export default component.exports